import { useState, useEffect, useRef } from 'react';
import { applyPageLayout } from './pageLayout';
import type { PageLayout } from './pageLayout';

type UsePageLayout = (initialLayout: PageLayout) => {
  layout: PageLayout;
  enterSearch: () => void;
  leaveSearch: () => void;
  setBannerHidden: (hidden: boolean) => void;
};

const usePageLayout: UsePageLayout = (initialLayout) => {
  const [layout, setLayout] = useState(initialLayout);
  const appliedLayout = useRef(initialLayout);

  const enterSearch = () => setLayout((prev) => (prev.searching ? prev : { ...prev, searching: true }));
  const leaveSearch = () => setLayout((prev) => ({ ...prev, searching: false }));
  const setBannerHidden = (bannerHidden: boolean) => setLayout((prev) => ({ ...prev, bannerHidden }));

  useEffect(() => {
    if (layout === appliedLayout.current) return;

    applyPageLayout(layout, appliedLayout.current);
    appliedLayout.current = layout;
  }, [layout]);

  // A search starts with any search for games, wherever it comes from (the filters, a typed name
  // once it is searched for, the sidebar links).
  useEffect(() => {
    document.addEventListener('casinoSearch', enterSearch);
    return () => {
      document.removeEventListener('casinoSearch', enterSearch);
    };
  }, []);

  return { layout, enterSearch, leaveSearch, setBannerHidden };
};

export default usePageLayout;
